import { useState } from "react";
import { apisavecourseName } from "../../services/courses/apicourses";
import toast from "react-hot-toast";
import { Dialog } from "primereact/dialog";

export default function Addhookform (props) {

    const { hookVisible, setHookVisible } = props;

    const [currentaffairstype, setCurrentaffairstype] = useState("");
    const [currentAffairsCategory, setcurrentAffairsCategory] = useState("");

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === "currentaffairstype") {
            setCurrentaffairstype(value);
        } else if (name === "currentAffairsCategory") {
            setcurrentAffairsCategory(value);
        }
    };

    const handleSave = async (e) => {
        e.preventDefault();
        const data = { currentaffairstype, currentAffairsCategory };
        const response = await apisavecourseName(data);
        if (response.message === "Successfully saved") {
            toast.success("Saved successfully.");
            setHookVisible(false);
            setCurrentaffairstype("");
            setcurrentAffairsCategory("");
        } else {
            toast.error("Failed to save current affairs hooks. Please try again.");
        }
    };

    return (
        <>
            <Dialog header="Add CA type or Category Form" visible={hookVisible} onHide={() => { if (!hookVisible) return; setHookVisible(false); }} style={{ width: '30vw' }} breakpoints={{ '960px': '75vw', '641px': '100vw' }} maximizable>
                <form onSubmit={handleSave}>
                    <div>
                        <div>
                            <label>Current Affairs Type</label>
                        </div>
                        <input type="text" name="currentaffairstype" value={currentaffairstype} className="w-full px-4 py-2 mt-1 border outline-none rounded-xl" onChange={handleChange}/>
                    </div>
                    <div className="mt-3">
                        <div>
                            <label>Current Affairs Category</label>
                        </div>
                        <input type="text" name="currentAffairsCategory" value={currentAffairsCategory} className="w-full px-4 py-2 mt-1 border outline-none rounded-xl" onChange={handleChange}/>
                    </div>
                    <button type="submit" className="p-2 px-4 mt-5 text-white bg-secondary rounded-xl" > 
                        <i className="mr-1 fi fi-br-check"></i>Save
                    </button>
                </form>
            </Dialog>
        </>
    )
}